<ng-template ng-footer-tmp let-searchResults="searchResults" let-select="select" let-addTagText="addTagText">
   <span
     class="add-new"
     *ngIf="searchResults?.term?.length > minInputLength"
     (click)="onAddNewItem(searchResults.term); select.close()">
      {{addTagText | translate}}: {{searchResults.term}}
   </span>
</ng-template>
